<p>join-league works!</p>
